import { getDefaultAgeCategoryId, querySchema, SimpleCompetitionTypeToIdMap } from '../components/query-schema';
import { useFilterForm } from '~/hooks/useFilterForm';
import { useRecordListQuery } from '../../queries';

export function useRecordList() {
  const { values } = useFilterForm(querySchema.parse);

  const query = useRecordListQuery({
    competition_types: SimpleCompetitionTypeToIdMap[values.competition_type],
    age_category: values.age_category_id ?? getDefaultAgeCategoryId(values.competition_type),
    district: values.district_id,
    is_male: values.sex === 'M',
  });

  return query;
}
